import React from 'react';
import styled from 'styled-components';

import RecruitmentForm from './RecruitmentForm';
import { useTranslation, Trans } from 'react-i18next';

const endRekryDate = new Date('2026-05-25T23:59:59+03:00');

const Main = styled.main`
  background-color: ${(p) => p.theme.color.containerBg};
  padding: 1rem;

  p {
    max-width: 700px;
  }
`;

const Recruitment = () => {
  const { t } = useTranslation();
  return (
    <Main>
      <h1>{t('rekry.title')}</h1>
      <p>{t('rekry.paragraph1')}</p>
      <p>{t('rekry.paragraph2')}</p>
      <p>
        <Trans
          i18nKey="rekry.paragraph3"
          components={[<a href="mailto:rekry@radiodiodi.fi"> </a>]}
        />
      </p>

      {new Date() >= endRekryDate ? (
        <h1>{t('rekry.closed')}</h1>
      ) : (
        <RecruitmentForm />
      )}
    </Main>
  );
};

export default Recruitment;
